import type { ClarifyMessage, ClarifyOption } from '../types.js';
import { Digits } from '../blocks/Digits.js';

export interface ClarifyCardProps {
  readonly message: ClarifyMessage;
  readonly onChoose: (message: ClarifyMessage, option: ClarifyOption) => void;
  /** An answer is being produced - choices wait. */
  readonly busy: boolean;
}

/** Frame E - «منظورتان کدام است؟»: option buttons that continue with a scripted answer; costs no tokens. */
export function ClarifyCard({ message, onChoose, busy }: ClarifyCardProps) {
  const answered = message.chosenId !== undefined;
  return (
    <div className="sk-card ai-state ai-clarify">
      <div className="ai-clarify__question">{message.question}</div>
      <div className="ai-clarify__options" role="group" aria-label="گزینه‌های پاسخ">
        {message.options.map((option) => {
          const chosen = option.id === message.chosenId;
          return (
            <button
              key={option.id}
              type="button"
              className="sk-btn sk-btn--secondary ai-clarify__option"
              data-chosen={chosen}
              aria-pressed={answered ? chosen : undefined}
              disabled={answered || busy}
              onClick={() => onChoose(message, option)}
            >
              <Digits>{option.label}</Digits>
            </button>
          );
        })}
      </div>
      <div className="ai-state__foot">پرسش روشن‌کننده توکن مصرف نمی‌کند.</div>
    </div>
  );
}
